module.exports = __webpack_public_path__ + "static/media/error.40733204.svg";